{
  "contactModal": {
    "delete": {
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "error": {
        "contactWithInformationRequests": "Impossible de supprimer le contact avec des demandes d'informations assignées",
        "default": "Erreur lors de la suppression du contact",
        "title": "Erreur lors de la suppression du contact"
      },
      "message": "Voulez-vous vraiment supprimer le partenaire commercial sélectionné ? Cette action est irrévocable.",
      "success": "Contact supprimé avec succès",
      "title": "Confirmation"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Nouveau"
    },
    "table": {
      "headers": {
        "actions": "Actions",
        "email": "Contact Email",
        "id": "ID",
        "name": "Nom du site"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "Annuler",
      "delete": "Supprimer",
      "save": "Sauvegarder"
    },
    "createTitle": "Nouveau site de production",
    "delete": {
      "cancel": "Non",
      "confirm": "Oui",
      "message": "Êtes-vous sûr de vouloir supprimer ce site de production ?",
      "title": "Confirmation"
    },
    "editTitle": "Site de production",
    "errors": {
      "cityRequired": "La ville est requise",
      "coordinatesMaxDecimals": "La latitude et la longitude ne peuvent pas depasser 6 decimales",
      "countryMustBeValid": "Doit être un pays valide (ex. FR, DE)",
      "internalCodeTooLong": "Le code interne ne doit pas dépasser 32 caractères",
      "nameRequired": "Le nom est requis",
      "parentCompanyRequired": "L'entreprise est requise",
      "postalCodeTooShort": "Le code postal doit comporter au moins 3 caracteres",
      "streetRequired": "La rue est requise",
      "streetTooShort": "La rue doit comporter au moins 3 caracteres"
    },
    "labels": {
      "city": "Ville",
      "country": "Pays",
      "internalCode": "Autre code interne",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "name": "Nom du site",
      "parentCompany": "Entreprise",
      "performedActivities": "Activités",
      "postalCode": "Code postal",
      "registrationId": "Identifiants professionnels du site",
      "street": "Rue"
    },
    "placeholders": {
      "city": "ex. Casablanca",
      "country": "Sélectionnez le pays du site",
      "internalCode": "ex. BD-DAK-001 ou votre référence interne",
      "latitude": "ex. 48.8566",
      "longitude": "ex. 2.3522",
      "name": "ex. Unité Coupe et Couture Dhaka A",
      "performedActivities": "ex. Coupe, couture, finition, teinture",
      "postalCode": "ex. 75008",
      "registrationId": "ex. N° TVA, CIN, GSTIN, USC",
      "street": "ex. 12 rue des Fleurs"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS : 9 chiffres.",
      "EORI": "EORI : code pays + 14 chiffres.",
      "GLN": "GLN : 13 chiffres.",
      "OTHER": "Autre : max 32 caractères.",
      "RCS": "RCS : RCS + espace + nom entreprise + espace + [A,B] + espace + 9 chiffres.",
      "VAT": "TVA : code pays (ex. FR) + clé 2 chiffres + numéro SIREN 9 chiffres."
    },
    "registrationIdErrors": {
      "DUNS": "L'identifiant DUNS doit être un numéro à 9 chiffres.",
      "EORI": "L'identifiant EORI doit être au format : code pays (ex. FR) + 14 chiffres.",
      "GLN": "L'identifiant GLN doit être un numéro à 13 chiffres.",
      "OTHER": "L'identifiant autre doit contenir moins de 32 caractères.",
      "RCS": "L'identifiant RCS doit être au format : RCS + espace + nom entreprise + espace + [A,B] + espace + 9 chiffres.",
      "VAT": "L'identifiant TVA doit être au format : code pays (ex. FR) + clé 2 chiffres + numéro SIREN 9 chiffres."
    },
    "tabs": {
      "generalInfo": "Information",
      "location": "Localisation"
    },
    "tooltips": {
      "address": "Adresse complète du site. Sert à identifier et à tracer ce lieu dans vos dossiers.",
      "city": "Ville ou commune où se trouve le site.",
      "country": "Pays où le site est implanté.",
      "internalCode": "Code court interne que votre équipe utilise pour reconnaître ce site.",
      "latitude": "Facultatif : latitude du site en degrés décimaux (ex. 48.8566).",
      "longitude": "Facultatif : longitude du site en degrés décimaux (ex. 2.3522).",
      "name": "Nom utilisé en interne pour désigner ce site.",
      "parentCompany": "Entreprise propriétaire de l'usine, sélectionnée parmi les partenaires commerciaux enregistrés.",
      "performedActivities": "Ce que fait le site (ex. transformation, conditionnement, stockage).",
      "postalCode": "Code postal du lieu où se trouve le site.",
      "registrationId": "Identifiant officiel ou d'immatriculation du site (TVA, CIN, GSTIN, USC, etc.).",
      "street": "Numéro et libellé de voie pour l'adresse du site."
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Nouveau"
    },
    "create": {
      "error": "Erreur lors de la création du site de production",
      "success": {
        "message": "Le site de production a été créé avec succès",
        "title": "Site de production créé"
      }
    },
    "delete": {
      "error": "Erreur lors de la suppression du site de production",
      "success": {
        "message": "Le site de production a été supprimé avec succès",
        "title": "Site de production supprimé"
      }
    },
    "filters": {
      "country": "Pays",
      "internalCode": "Autre code interne",
      "isConfidential": "Confidentiel",
      "isConfidentialFalse": "Non",
      "isConfidentialTrue": "Oui",
      "name": "Nom du site",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Activités réalisées",
      "searchPlaceholder": "Rechercher les filtres",
      "title": "Filtres"
    },
    "search": {
      "placeholder": "Rechercher par nom ou adresse"
    },
    "sorts": {
      "address": "Localisation",
      "country": "Pays",
      "email": "Email",
      "internalCode": "Autre code interne",
      "name": "Nom"
    },
    "table": {
      "headers": {
        "address": "Localisation",
        "certificates": "Certificats",
        "deleted": "Supprimé",
        "id": "ID",
        "internalCode": "Autre code interne",
        "name": "Nom du site",
        "parentCompany": "Entreprise",
        "performedActivities": "Activités",
        "registrationId": "Identifiants professionnels du site"
      }
    },
    "title": "Sites de production",
    "update": {
      "error": "Erreur lors de la mise à jour du site de production",
      "success": {
        "message": "Le site de production a été mis à jour avec succès",
        "title": "Site de production mis à jour"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Erreur"
    }
  }
}
